import { memo } from 'react';
import { hasCalories } from 'utils';
import { AztecPortion } from 'types/models';
import { MenuItemDescription } from 'menu/components/MenuItemDescription';
import { CalorieUnit } from 'menu/components/Calories';
import cs from 'classnames';

interface PortionItemProps {
  portion: AztecPortion;
  isSelectedPortion?: boolean;
}

export const PortionInfo: React.FC<PortionItemProps> = memo(
  ({ portion, isSelectedPortion = false }) => {
    const portionHasCalories = hasCalories(portion.calories);

    const portionClassnames = cs(
      'portion-info',
      isSelectedPortion ? 'portion-info-selected' : '',
    );

    return (
      <div className={portionClassnames}>
        <div className="portion-name">{portion.name}</div>
        {portionHasCalories ? (
          <div className="text-muted">
            {portion.calories} <CalorieUnit />
          </div>
        ) : null}
        {portion.description ? (
          <MenuItemDescription description={portion.description} />
        ) : null}
      </div>
    );
  },
);
